import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ko: {
    translation: {
      "nav_social": "소셜",
      "nav_master": "강사",
      "nav_class": "수업/정모",
      "nav_bootcamp": "부트캠프",
      "nav_festival": "페스티벌",
      "nav_party": "SOCIAL",
      "nav_register": "등록",

      "filter_where": "어디로 가시나요?",
      "filter_genre": "어떤 장르가 꽂히세요?",
      "map": "지도",
      "view_all": "전체보기",
      "today": "오늘",
      "hot_pick": "HOT PICK 5",
      "view_calendar": "달력",
      "no_parties": "이 지역은 아직 등록된 파티가 없습니다.",
      "back_to_today": "오늘로 돌아가기",
      "premium_services": "Premium Services",
      "platform_desc": "지능형 댄스 라이프 플랫폼",
      "restaurant": "뒷풀이 맛집",
      "saju": "운명의 좌표",
      "weather": "오늘 날씨",
      "notice": "공지사항",
      "coming_soon": "준비 중입니다",
      "intelligent_route": "지능형 경로 최적화",
      "region_seoul": "서울",
      "region_gyeonggi_incheon": "경인",
      "region_gyeongsang": "경상도",
      "region_jeolla": "전라도",
      "region_chungcheong": "충청도",
      "region_gangwon_jeju": "강원/제주",
      "region_gangwon": "강원",
      "region_jeju": "제주",
      "region_incheon": "인천",
      "region_busan": "부산",
      "region_daegu": "대구",
      "region_daejeon": "대전",
      "region_gwangju": "광주",
      "region_etc": "기타",
      "today_bootcamp": "오늘의 부트캠프",
      "today_festival": "오늘의 페스티벌",
      "confirm_complete": "확인 완료",
      "reselect_region": "지역 다시 선택",
      "reselect_genre": "장르 다시 선택",
      "no_matching_parties": "해당 조건의 파티가 없습니다 😅",
      "open_chat": "실시간 오픈톡",
      "weather_title": "🗺️ 전국 날씨",
      "weather_desc": "오늘 밤 파티 날씨 실시간 안내",
      "weather_source": "기상청 단기예보 (05:00 기준)",
      "weather_error": "데이터 오류",
      "admin_portal": "관리자 포털",
      "admin_portal_desc": "관리하실 항목을 선택해주세요.",
      "admin_manage_party": "소셜파티 관리",
      "back_to_main": "메인으로 돌아가기",
      "live_msg_1": "오늘 밤도 전국 플로어는 뜨겁습니다 🔥",
      "live_msg_2": "지금 이 순간, 어딘가에서 음악이 흐르고 있어요 🎵",
      "live_msg_3": "오늘 밤 파티, 아직 자리 있어요 💃",
      "live_msg_4": "전국 댄서들이 지금 움직이고 있어요 ✨",
      "live_msg_5": "플로어 위에서 만나요, 오늘 밤 🌙",
      "live_msg_6": "음악이 있는 곳에 당신의 밤이 있어요 🎶",
      "live_msg_7": "처음이어도 괜찮아요, 파티는 열려 있어요 🚪",
      "live_msg_8": "지금 근처 파티를 찾아보세요 📍",
      "live_msg_9": "오늘 밤의 선택이 새로운 인연을 만들어요 💫",
      "live_msg_10": "전국 어디서든, 만원이면 충분해요 🎉",
      "live_msg_11": "좋은 음악, 좋은 사람, 오늘 밤 여기 🌟",
      "live_msg_12": "퇴근 후 뭐하지? 답은 플로어에 있어요 👟",
      "live_msg_13": "혼자여도 괜찮아요, 플로어에선 모두가 친구예요 🤝",
      "live_msg_14": "오늘 밤만큼은 특별하게 💎",
      "live_msg_15": "지금 체크인하면 오늘 밤이 달라져요 🗺️",
      "weather_rain": "비",
      "weather_rain_snow": "비/눈",
      "weather_snow": "눈",
      "weather_clear": "맑음",
      "weather_partly_cloudy": "구름조금",
      "weather_cloudy": "흐림",
      "badge_indoor_party": "실내 파티!",
      "badge_be_careful": "조심조심!",
      "badge_snow_dance": "설경 댄스!",
      "badge_party_go": "파티 GO!",
      "badge_perfect_dance": "춤추기 딱!",
      "badge_indoor_social": "실내 소셜!",
      "close": "닫기",
      "saju_title": "🔮 댄스 사주 분석",
      "saju_desc": "당신에게 딱 맞는 댄스 라이프를 찾아보세요",
      "saju_gender": "성별",
      "saju_male": "♂ 남성",
      "saju_female": "♀ 여성",
      "saju_experience": "🐣 댄스 경력",
      "saju_beginner": "처음이에요 / 입문",
      "saju_beginner_desc": "처음이거나 6개월 미만",
      "saju_experienced": "경력자예요",
      "saju_experienced_desc": "이미 춤을 추고 있어요 (6개월 이상)",
      "saju_birth_year": "생년",
      "saju_birth_month": "월",
      "saju_birth_day": "일",
      "saju_birth_time": "태어난 시간",
      "saju_birth_time_unknown": "모름",
      "saju_analyze_btn": "🔮 나의 댄스 사주 분석하기",
      "saju_analyzing": "🔮 분석 중...",
      "saju_view_today": "🔮 오늘의 분석 결과 보기",
      "saju_mission": "✨ 미션",
      "saju_recommend_bar": "🎯 당신을 위한 추천 BAR",
      "saju_join_chat": "💬 오픈톡 입장하기",
      "saju_retry": "🔄 다시 분석하기",
      "saju_info_found": "반갑습니다! 기존 정보를 찾았습니다.",
      "saju_edit_info": "정보 수정하기",
      "saju_first_step": "🌱 첫 걸음이 가장 용감합니다",
      "saju_start_today": "오늘 시작하는 것이 모든 것입니다",
      "saju_vibe_guide": "📜 오늘의 바이브 가이드"
    }
  },
  en: {
    translation: {
      "nav_social": "SOCIAL",
      "nav_master": "MASTER",
      "nav_class": "Classes",
      "nav_bootcamp": "BOOTCAMP",
      "nav_festival": "FESTIVAL",
      "nav_party": "SOCIAL",
      "nav_register": "Register",

      "filter_where": "Where are you going?",
      "filter_genre": "What's your vibe?",
      "map": "Map",
      "view_all": "View All",
      "today": "Today",
      "hot_pick": "HOT PICK 5",
      "view_calendar": "Calendar",
      "no_parties": "No parties registered here yet.",
      "back_to_today": "Back to Today",
      "premium_services": "Premium Services",
      "platform_desc": "Intelligent Dance Life Platform",
      "restaurant": "Top Restaurants",
      "saju": "Fortune",
      "weather": "Weather",
      "notice": "Notice",
      "coming_soon": "Coming Soon",
      "intelligent_route": "Intelligent Route",
      "region_seoul": "SEOUL",
      "region_gyeonggi_incheon": "INCHEON/GYEONGGI",
      "region_gyeongsang": "GYEONGSANG",
      "region_jeolla": "JEOLLA",
      "region_chungcheong": "CHUNGCHEONG",
      "region_gangwon_jeju": "GANGWON/JEJU",
      "region_gangwon": "GANGWON",
      "region_jeju": "JEJU",
      "region_incheon": "INCHEON",
      "region_busan": "BUSAN",
      "region_daegu": "DAEGU",
      "region_daejeon": "DAEJEON",
      "region_gwangju": "GWANGJU",
      "region_etc": "ETC",
      "today_bootcamp": "TODAY'S BOOTCAMP",
      "today_festival": "TODAY'S FESTIVAL",
      "confirm_complete": "CONFIRM",
      "reselect_region": "Reselect Region",
      "reselect_genre": "Reselect Genre",
      "no_matching_parties": "No matching parties found 😅",
      "open_chat": "Live Open Chat",
      "weather_title": "🗺️ National Weather",
      "weather_desc": "Real-time weather for tonight's party",
      "weather_source": "KMA Short-term Forecast (05:00)",
      "weather_error": "Data Error",
      "admin_portal": "Admin Portal",
      "admin_portal_desc": "Please select an item to manage.",
      "admin_manage_party": "Manage Social Parties",
      "back_to_main": "Back to Main",
      "live_msg_1": "The dance floor is hot tonight across the country 🔥",
      "live_msg_2": "At this moment, music is flowing somewhere 🎵",
      "live_msg_3": "Tonight's party still has spots left 💃",
      "live_msg_4": "Dancers nationwide are moving right now ✨",
      "live_msg_5": "See you on the floor tonight 🌙",
      "live_msg_6": "Where there is music, there is your night 🎶",
      "live_msg_7": "It's okay to be a first-timer, the party is open 🚪",
      "live_msg_8": "Find a party near you right now 📍",
      "live_msg_9": "Tonight's choice creates new connections 💫",
      "live_msg_10": "Anywhere in the country, 10,000 won is enough 🎉",
      "live_msg_11": "Good music, good people, right here tonight 🌟",
      "live_msg_12": "What to do after work? The answer is on the floor 👟",
      "live_msg_13": "It's okay to be alone, everyone's a friend on the floor 🤝",
      "live_msg_14": "Make tonight special 💎",
      "live_msg_15": "Check in now and your night will change 🗺️",
      "weather_rain": "Rainy",
      "weather_rain_snow": "Rain/Snow",
      "weather_snow": "Snowy",
      "weather_clear": "Clear",
      "weather_partly_cloudy": "Partly Cloudy",
      "weather_cloudy": "Cloudy",
      "badge_indoor_party": "Indoor Party!",
      "badge_be_careful": "Watch Out!",
      "badge_snow_dance": "Snow Dance!",
      "badge_party_go": "Party GO!",
      "badge_perfect_dance": "Perfect Day!",
      "badge_indoor_social": "Indoor Social!",
      "close": "CLOSE",
      "saju_title": "🔮 Dance Saju Analysis",
      "saju_desc": "Find the perfect dance life for you",
      "saju_gender": "Gender",
      "saju_male": "♂ Male",
      "saju_female": "♀ Female",
      "saju_experience": "🐣 Dance Experience",
      "saju_beginner": "Beginner / Intro",
      "saju_beginner_desc": "First time or less than 6 months",
      "saju_experienced": "Experienced",
      "saju_experienced_desc": "Already a dancer (6+ months)",
      "saju_birth_year": "Year",
      "saju_birth_month": "Month",
      "saju_birth_day": "Day",
      "saju_birth_time": "Birth Time",
      "saju_birth_time_unknown": "Unknown",
      "saju_analyze_btn": "🔮 Analyze my Dance Saju",
      "saju_analyzing": "🔮 Analyzing...",
      "saju_view_today": "🔮 View Today's Fortune",
      "saju_mission": "✨ Mission",
      "saju_recommend_bar": "🎯 Recommended BAR for You",
      "saju_join_chat": "💬 Join Open Chat",
      "saju_retry": "🔄 Analyze again?",
      "saju_info_found": "Welcome back! Found your info.",
      "saju_edit_info": "Edit info",
      "saju_first_step": "🌱 The first step is the bravest",
      "saju_start_today": "Starting today is everything",
      "saju_vibe_guide": "📜 Today's Vibe Guide"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
